"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function LayoutIconCircleImageTextSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 112, height: 77, viewBox: "0 0 112 77" }, props),
        react_1.default.createElement("g", { fill: "#597EFF", fillRule: "evenodd" },
            react_1.default.createElement("g", { transform: "translate(41 11)" },
                react_1.default.createElement("rect", { width: 30, height: 30, fillOpacity: 0.1, rx: 15 }),
                react_1.default.createElement("path", { fillRule: "nonzero", d: "M16.93 10.833L22 20H8l3.897-7.097 1.937 3.526 3.096-5.596zM10.27 9c.836 0 1.514.657 1.514 1.467s-.678 1.466-1.514 1.466-1.513-.656-1.513-1.466c0-.81.677-1.467 1.513-1.467z", opacity: 0.2 })),
            react_1.default.createElement("path", { d: "M84 64v2H29v-2h55zm12-7v2H16v-2h80zm-9-11v6H25v-6h62z", opacity: 0.4 })));
}
function LayoutIconCircleImageText(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(LayoutIconCircleImageTextSvg, Object.assign({}, svgProps)));
}
exports.default = LayoutIconCircleImageText;
//# sourceMappingURL=LayoutIconCircleImageText.js.map